import { render, staticRenderFns } from "./Sparkline.vue?vue&type=template&id=63b9bcf5"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports